module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iconTabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('iconTab', {
    attrs: {
      "header": "Console",
      "leftIcon": "list-alt"
    }
  }, [_c('console')], 1), _vm._v(" "), (_vm.session != null) ? _c('div', _vm._l((_vm.session.agentMap), function(agentType, agentTypeName, index) {
    return _c('iconTab', {
      key: agentType.name,
      attrs: {
        "header": agentTypeName,
        "leftIcon": "user-secret",
        "rightIcon": agentType.state.tabIcon
      }
    }, [_c('codearea', {
      attrs: {
        "agentType": agentType
      },
      on: {
        "focus": function($event) {
          _vm.activateAgentTab(index)
        }
      }
    })], 1)
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-834d70fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workbench/EditorTabs.vue
// module id = 1546
// module chunks = 2